import { Descriptions, Select, Spin } from 'antd';
import React from 'react'

const OldSouscripteurForm = ({ oldClient, setOldClient, clients, clientSearch, setClientSearch, cSelected, setCSelected, loading }) => {
    return (
        <div className="row g-6">
            <div className="col-sm-12">
                <Select
                    showSearch
                    placeholder="Selectionnez le client pour lequel vous voulez établir un contrat. vous pouvez faire une recherche dynamique......"
                    optionFilterProp="children"
                    filterOption={false}
                    notFoundContent={loading ? <Spin size="small" /> : "Aucun résultat"}
                    onChange={(e) => {
                        setOldClient(JSON.parse(e));
                        setCSelected(true);
                    }}
                    onSearch={(e) => {
                        setClientSearch(e);
                    }}
                    searchValue={clientSearch}
                    options={clients}
                    style={{ width: "100%" }}
                    allowClear
                />
            </div>
            <div className="col-sm-12">
                {cSelected && (<div className="col-sm-12">
                    <Descriptions
                        title={`Assuré N° ${oldClient.numeroAssureM ? oldClient.numeroAssureM : oldClient.numeroAssureP ? oldClient.numeroAssureP : "---"}`}
                        size={"default"}
                    >
                        <Descriptions.Item label="Nom et prénom(s)">
                            {oldClient.prenom ? `${oldClient.nom} ${oldClient.prenom}` : `${oldClient.nom}`}
                        </Descriptions.Item>
                        {oldClient.typePersonne && oldClient.typePersonne === "PHYSIQUE" && (
                            <Descriptions.Item label="Genre">
                                {oldClient.genre}
                            </Descriptions.Item>)}
                        {oldClient.adresse && (<Descriptions.Item
                            label={oldClient.typePersonne === "PHYSIQUE" ? "Adresse de résidence" : "Siège social"}
                        >
                            {oldClient.adresse}
                        </Descriptions.Item>)}
                        {oldClient.email && (
                            <Descriptions.Item label="Adresse mail">
                                {oldClient.email}
                            </Descriptions.Item>)}
                        {oldClient.contact?.length && (
                            <Descriptions.Item label="Contact(s)">
                                {oldClient.contact[0]} {oldClient.contact[1] && oldClient.contact[1]}
                            </Descriptions.Item>)}
                        {oldClient.profession && (
                            <Descriptions.Item label="Profession">
                                {oldClient.profession}
                            </Descriptions.Item>)}
                    </Descriptions>
                </div>)}
            </div>
        </div>
    )
}

export default OldSouscripteurForm